import styles from "./terms.module.scss";
import * as React from "react";
import Header from "@components/Header";
import useIntersectionObserver from "src/hooks/useIntersectionObserver";

type Props = {};

const Terms: React.FC<Props> = (props) => {
  const ref = React.useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(ref, {});
  const isVisible = !!entry?.isIntersecting;
  const ref2 = React.useRef<HTMLDivElement | null>(null);
  const entry2 = useIntersectionObserver(ref2, {});
  const isVisible2 = !!entry2?.isIntersecting;
  const ref3 = React.useRef<HTMLDivElement | null>(null);
  const entry3 = useIntersectionObserver(ref3, {});
  const isVisible3 = !!entry3?.isIntersecting;
  const ref4 = React.useRef<HTMLDivElement | null>(null);
  const entry4 = useIntersectionObserver(ref4, {});
  const isVisible4 = !!entry4?.isIntersecting;
  const ref5 = React.useRef<HTMLDivElement | null>(null);
  const entry5 = useIntersectionObserver(ref5, {});
  const isVisible5 = !!entry5?.isIntersecting;
  const ref6 = React.useRef<HTMLDivElement | null>(null);
  const entry6 = useIntersectionObserver(ref6, {});
  const isVisible6 = !!entry6?.isIntersecting;
  const ref7 = React.useRef<HTMLDivElement | null>(null);
  const entry7 = useIntersectionObserver(ref7, {});
  const isVisible7 = !!entry7?.isIntersecting;
  const ref8 = React.useRef<HTMLDivElement | null>(null);
  const entry8 = useIntersectionObserver(ref8, {});
  const isVisible8 = !!entry8?.isIntersecting;
  const ref9 = React.useRef<HTMLDivElement | null>(null);
  const entry9 = useIntersectionObserver(ref9, {});
  const isVisible9 = !!entry9?.isIntersecting;
  const ref10 = React.useRef<HTMLDivElement | null>(null);
  const entry10 = useIntersectionObserver(ref10, {});
  const isVisible10 = !!entry10?.isIntersecting;
  const ref11 = React.useRef<HTMLDivElement | null>(null);
  const entry11 = useIntersectionObserver(ref11, {});
  const isVisible11 = !!entry11?.isIntersecting;
  const ref12 = React.useRef<HTMLDivElement | null>(null);
  const entry12 = useIntersectionObserver(ref12, {});
  const isVisible12 = !!entry12?.isIntersecting;
  const ref13 = React.useRef<HTMLDivElement | null>(null);
  const entry13 = useIntersectionObserver(ref13, {});
  const isVisible13 = !!entry13?.isIntersecting;
  const ref14 = React.useRef<HTMLDivElement | null>(null);
  const entry14 = useIntersectionObserver(ref14, {});
  const isVisible14 = !!entry14?.isIntersecting;
  const ref15 = React.useRef<HTMLDivElement | null>(null);
  const entry15 = useIntersectionObserver(ref15, {});
  const isVisible15 = !!entry15?.isIntersecting;
  const ref16 = React.useRef<HTMLDivElement | null>(null);
  const entry16 = useIntersectionObserver(ref16, {});
  const isVisible16 = !!entry16?.isIntersecting;
  const ref17 = React.useRef<HTMLDivElement | null>(null);
  const entry17 = useIntersectionObserver(ref17, {});
  const isVisible17 = !!entry17?.isIntersecting;
  const ref18 = React.useRef<HTMLDivElement | null>(null);
  const entry18 = useIntersectionObserver(ref18, {});
  const isVisible18 = !!entry18?.isIntersecting;
  const ref19 = React.useRef<HTMLDivElement | null>(null);
  const entry19 = useIntersectionObserver(ref19, {});
  const isVisible19 = !!entry19?.isIntersecting;
  const ref20 = React.useRef<HTMLDivElement | null>(null);
  const entry20 = useIntersectionObserver(ref20, {});
  const isVisible20 = !!entry20?.isIntersecting;
  const ref21 = React.useRef<HTMLDivElement | null>(null);
  const entry21 = useIntersectionObserver(ref21, {});
  const isVisible21 = !!entry21?.isIntersecting;
  const ref22 = React.useRef<HTMLDivElement | null>(null);
  const entry22 = useIntersectionObserver(ref22, {});
  const isVisible22 = !!entry22?.isIntersecting;
  const ref23 = React.useRef<HTMLDivElement | null>(null);
  const entry23 = useIntersectionObserver(ref23, {});
  const isVisible23 = !!entry23?.isIntersecting;
  const ref24 = React.useRef<HTMLDivElement | null>(null);
  const entry24 = useIntersectionObserver(ref24, {});
  const isVisible24 = !!entry24?.isIntersecting;
  const ref25 = React.useRef<HTMLDivElement | null>(null);
  const entry25 = useIntersectionObserver(ref25, {});
  const isVisible25 = !!entry25?.isIntersecting;
  const ref26 = React.useRef<HTMLDivElement | null>(null);
  const entry26 = useIntersectionObserver(ref26, {});
  const isVisible26 = !!entry26?.isIntersecting;
  const ref27 = React.useRef<HTMLDivElement | null>(null);
  const entry27 = useIntersectionObserver(ref27, {});
  const isVisible27 = !!entry27?.isIntersecting;
  const ref28 = React.useRef<HTMLDivElement | null>(null);
  const entry28 = useIntersectionObserver(ref28, {});
  const isVisible28 = !!entry28?.isIntersecting;
  const scrollRef = React.useRef<HTMLLIElement | null>(null);
  const scrollRef2 = React.useRef<HTMLLIElement | null>(null);

  React.useEffect(() => {
    if (scrollRef.current && scrollRef2.current !== null) {
      if (isVisible) {
        scrollRef.current.scrollIntoView();
      } else if (isVisible28) {
        scrollRef2.current.scrollIntoView();
      }
    }
  }, [isVisible, isVisible28]);

  return (
    <div className={styles["terms"]} data-scroll-section>
      <Header />

      <div className={styles["terms__top"]}>
        <h1 className={styles["terms__top__heading"]}>
          Terms &amp; Conditions
        </h1>
        <p className={styles["terms__top__sub"]}>
          Last Updated : 20th February 2023
        </p>
      </div>

      <div className={styles["terms__container"]}>
        <div className={styles["terms__left"]}>
          <h4>Page Guide</h4>

          <ol>
            <li
              style={
                isVisible ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
              ref={scrollRef}
            >
              <a href="#introduction">1. Introduction</a>
            </li>
            <li
              style={
                isVisible2 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#communications">2. Communications/Opt-in</a>
            </li>
            <li
              style={
                isVisible3 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#purchases">3. Purchases</a>
            </li>
            <li
              style={
                isVisible4 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#contests">4. Contests, Sweepstakes and Promotions</a>
            </li>
            <li
              style={
                isVisible5 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#subscriptions">5. Subscriptions</a>
            </li>
            <li
              style={
                isVisible6 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#autodeletion">
                6. Automatic Deletion/ Extension option
              </a>
            </li>
            <li
              style={
                isVisible7 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#trial">7. Free Trial</a>
            </li>
            <li
              style={
                isVisible8 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#fee-changes">8. Fee Changes</a>
            </li>
            <li
              style={
                isVisible9 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#refunds">9. Refunds</a>
            </li>
            <li
              style={
                isVisible10 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#content">10. Content</a>
            </li>
            <li
              style={
                isVisible11 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#prohibited-uses">11. Prohibited Uses</a>
            </li>
            <li
              style={
                isVisible12 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#analytics">12. Analytics</a>
            </li>
            <li
              style={
                isVisible13 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#minors">13. No Use By Minors</a>
            </li>
            <li
              style={
                isVisible14 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#accounts">14. Accounts</a>
            </li>
            <li
              style={
                isVisible15 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#intellectual-property">15. Intellectual Property</a>
            </li>
            <li
              style={
                isVisible16 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#copyright-property">16. Copyright Policy</a>
            </li>
            <li
              style={
                isVisible17 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#dmca">
                17. Notice and Procedure for Copyright Infringement Claims
              </a>
            </li>
            <li
              style={
                isVisible18 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#error-reporting">18. Error Reporting and Feedback</a>
            </li>
            <li
              style={
                isVisible19 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#links-to-sites">19. Links To Other Websites</a>
            </li>
            <li
              style={
                isVisible20 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#disclaimer-of-warranty">20. Disclaimer Of Warranty</a>
            </li>
            <li
              style={
                isVisible21 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#limitation-of-liability">21. Limitation Of Liability</a>
            </li>
            <li
              style={
                isVisible22 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#termination">22. Termination</a>
            </li>
            <li
              style={
                isVisible23 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#governing-law">23. Governing Law</a>
            </li>
            <li
              style={
                isVisible24 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#changes-to-service">24. Changes To Service</a>
            </li>
            <li
              style={
                isVisible25 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#amendments-to-terms">25. Amendments To Terms</a>
            </li>
            <li
              style={
                isVisible26 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#waiver-and-severability">26. Waiver And Severability</a>
            </li>
            <li
              style={
                isVisible27 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
            >
              <a href="#acknowledgement">27. Acknowledgement</a>
            </li>
            <li
              style={
                isVisible28 ? { fontWeight: "bold" } : { fontWeight: "normal" }
              }
              ref={scrollRef2}
            >
              <a href="#contact-us">28. Contact Us</a>
            </li>
          </ol>
        </div>

        <div className={styles["terms__right"]}>
          <h2 id="introduction">1. Introduction</h2>
          <p
            ref={(element) => {
              ref.current = element;
            }}
          >
            Welcome to <span className="bold">Inawo</span>, your first wedding
            planning resource!
            <br />
            <br />
            These Terms of Service (“Terms”, “Terms of Service”) govern your use
            of our website located at <span className="bold">
              Inawo.com
            </span>{" "}
            (together or individually “Service”) operated by{" "}
            <span className="bold">Inawo</span>. <br />
            <br />
            Our Privacy Policy also governs your use of our Service and explains
            how we collect, safeguard and disclose information that results from
            your use of our web pages. <br />
            <br />
            Your agreement with us includes these Terms and our Privacy Policy
            (“Agreements”). You acknowledge that you have read and understood
            Agreements, and agree to be bound by them. <br />
            <br />
            If you do not agree with (or cannot comply with) Agreements, then
            you may not use the Service, but please let us know by emailing at
            <a href="mailto:hello@inawo.co">hello@inawo.co</a> so we can try to
            find a solution. These Terms apply to all visitors, users and others
            who wish to access or use Service.
            <br />
            <br />
            These Terms of Service (“Terms”, “Terms of Service”) govern your use
            of our website located at Inawo.com (together or individually
            “Service”) operated by Inawo (otherwise referred to as, “we”, “our”,
            “company”).
          </p>

          <h2 id="communications">2. Communications/Opt-in</h2>
          <p
            ref={(element) => {
              ref2.current = element;
            }}
          >
            By using our Service, you agree to subscribe to notifications,
            marketing, newsletters or promotional materials and other
            information we may send through whatsapp, emails, sms or any other
            means of communication.
            <br />
            <br />
            However, you may opt out of receiving any, or all of these
            communications from us by following the unsubscribe link or by
            emailing at <a href="mailto:hello@inawo.co">hello@inawo.co</a>.
            <br />
          </p>

          <h2 id="purchases">3. Purchases</h2>
          <p
            ref={(element) => {
              ref3.current = element;
            }}
          >
            If you wish to purchase any product or service made available
            through Service (“Purchase”), you may be asked to supply certain
            information relevant to your Purchase including but not limited to,
            your credit or debit card number, the expiration date of your card,
            your billing address, and your shipping information.
            <br />
            You represent and warrant that:
            <br />
            (i) you have the legal right to use any card(s) or other payment
            method(s) in connection with any Purchase; and that
            <br />
            (ii) the information you supply to us is true, correct and complete.
            <br />
            <br />
            We may employ the use of third party services for the purpose of
            facilitating payment and the completion of Purchases. By submitting
            your information, you grant us the right to provide the information
            to these third parties subject to our Privacy Policy.
            <br />
            <br />
            We reserve the right to refuse or cancel your order at any time for
            reasons including but not limited to: product or service
            availability, errors in the description or price of the product or
            service, error in your order or other reasons.
            <br />
            <br />
            We reserve the right to refuse or cancel your order if fraud or an
            unauthorized or illegal transaction is suspected.
          </p>

          <h2 id="contests">4. Contests, Sweepstakes and Promotions</h2>
          <p
            ref={(element) => {
              ref4.current = element;
            }}
          >
            Any contests, sweepstakes or other promotions (collectively,
            “Promotions”) made available through Service may be governed by
            rules that are separate from these Terms of Service. If you
            participate in any Promotions, please review the applicable rules as
            well as our Privacy Policy. If the rules for a Promotion conflict
            with these Terms of Service, Promotion rules will apply.
          </p>

          <h2 id="subscriptions">5. Subscriptions</h2>
          <p
            ref={(element) => {
              ref5.current = element;
            }}
          >
            Some parts of Service are billed on a subscription basis
            (&quot;Subscription(s)&quot;). You will be billed in advance on a
            recurring and periodic basis (&quot;Billing Cycle&quot;). Billing
            cycles will be set depending on the type of subscription plan you
            select when purchasing a Subscription.
            <br />
            <br />
            At the end of each Billing Cycle, your Subscription will
            automatically renew under the exact same conditions unless you
            cancel it or Inawo cancels it. You may cancel your Subscription
            renewal either through your online account management page or by
            contacting <a href="mailto:hello@inawo.co">hello@inawo.co</a>{" "}
            customer support team.
            <br />
            <br />
            A valid payment method is required to process the payment for your
            subscription. You shall provide Inawo with accurate and complete
            billing information that may include but not limited to full name,
            address, state, postal or zip code, telephone number, and a valid
            payment method information. By submitting such payment information,
            you automatically authorize Inawo to charge all Subscription fees
            incurred through your account to any such payment instruments.
            <br />
            <br />
            Should automatic billing fail to occur for any reason, Inawo
            reserves the right to terminate your access to the Service with
            immediate effect.
          </p>

          <h2 id="autodeletion">6. Automatic Deletion/ Extension option</h2>
          <p
            ref={(element) => {
              ref6.current = element;
            }}
          >
            A period of 4 months after the scheduled date for an event (wedding)
            hosted on Inawo, Inawo reserves the right to delete an event created
            (which includes but is not limited to the free wedding website,
            invitation…). In order to extend or keep the event details on Inawo,
            different extension payment plans will be made available for you to
            select from.
          </p>

          <h2 id="trial">7. Free Trial</h2>
          <p
            ref={(element) => {
              ref7.current = element;
            }}
          >
            Inawo may, at its sole discretion, offer a Subscription with a free
            trial for a limited period of time (&quot;Free Trial&quot;).
            <br />
            <br />
            You may be required to enter your billing information in order to
            sign up for Free Trial. If you do enter your billing information
            when signing up for Free Trial, you will not be charged by Inawo
            until Free Trial has expired. On the last day of Free Trial period,
            unless you canceled your Subscription, you will be automatically
            charged the applicable Subscription fees for the type of
            Subscription you have selected.
            <br />
            <br />
            At any time and without notice, Inawo reserves the right to
            <br />
            (i) modify Terms of Service of Free Trial offer
            <br />
            (ii) cancel such Free Trial offer.
          </p>

          <h2 id="fee-changes">8. Fee Changes</h2>
          <p
            ref={(element) => {
              ref8.current = element;
            }}
          >
            Inawo, in its sole discretion and at any time, may modify
            Subscription fees for the Subscriptions. Any Subscription fee change
            will become effective at the end of the then-current Billing Cycle.
            <br />
            <br />
            Inawo will provide you with a reasonable prior notice of any change
            in Subscription fees to give you an opportunity to terminate your
            Subscription before such change becomes effective.
            <br />
            <br />
            Your continued use of Service after Subscription fee change comes
            into effect constitutes your agreement to pay the modified
            Subscription fee amount.
          </p>

          <h2 id="refunds">9. Refunds</h2>
          <p
            ref={(element) => {
              ref9.current = element;
            }}
          >
            We issue refunds for Contracts within 0 days of the original
            purchase of the Contract.
          </p>

          <h2 id="content">10. Content</h2>
          <p
            ref={(element) => {
              ref10.current = element;
            }}
          >
            Our Service allows you to post, link, store, share and otherwise
            make available certain information, text, graphics, videos, or other
            material (“Content”). You are responsible for Content that you post
            on or through Service, including its legality, reliability, and
            appropriateness.
            <br />
            <br />
            By posting Content on or through Service, You represent and warrant
            that:
            <br />
            (i) Content is yours (you own it) and/or you have the right to use
            it and the right to grant us the rights and license as provided in
            these Terms
            <br />
            (ii) that the posting of your Content on or through Service does not
            violate the privacy rights, publicity rights, copyrights, contract
            rights or any other rights of any person or entity. We reserve the
            right to terminate the account of anyone found to be infringing on a
            copyright.
            <br />
            <br />
            You retain any and all of your rights to any Content you submit,
            post or display on or through Service and you are responsible for
            protecting those rights. We take no responsibility and assume no
            liability for Content you or any third party posts on or through
            Service. However, by posting Content using Service you grant us the
            right and license to use, modify, publicly perform, publicly
            display, reproduce, and distribute such Content on and through
            Service. You agree that this license includes the right for us to
            make your Content available to other users of Service, who may also
            use your Content subject to these Terms.
            <br />
            <br />
            Inawo has the right but not the obligation to monitor and edit all
            Content provided by users.
            <br />
            <br />
            In addition, Content found on or through this Service are the
            property of Inawo or used with permission. You may not distribute,
            modify, transmit, reuse, download, repost, copy, or use said
            Content, whether in whole or in part, for commercial purposes or for
            personal gain, without express advance written permission from us.
          </p>

          <h2 id="prohibited-uses">11. Prohibited Uses</h2>
          <p
            ref={(element) => {
              ref11.current = element;
            }}
          >
            You may use Service only for lawful purposes and in accordance with
            Terms. You agree not to use Service:
            <br />
            <br />
            0.1. In any way that violates any applicable national or
            international law or regulation.
            <br />
            0.2. For the purpose of exploiting, harming, or attempting to
            exploit or harm minors in any way by exposing them to inappropriate
            content or otherwise.
            <br />
            0.3. To transmit, or procure the sending of, any advertising or
            promotional material, including any “junk mail”, “chain letter,”
            “spam,” or any other similar solicitation.
            <br />
            0.4. To impersonate or attempt to impersonate Company, a Company
            employee, another user, or any other person or entity.
            <br />
            0.5. In any way that infringes upon the rights of others, or in any
            way is illegal, threatening, fraudulent, or harmful, or in
            connection with any unlawful, illegal, fraudulent, or harmful
            purpose or activity.
            <br />
            0.6. To engage in any other conduct that restricts or inhibits
            anyone&apos;s use or enjoyment of Service, or which, as determined
            by us, may harm or offend Company or users of Service or expose them
            to liability.
            <br />
            <br />
            Additionally, you agree not to:
            <br />
            0.1. Use Service in any manner that could disable, overburden,
            damage, or impair Service or interfere with any other party&apos;s
            use of Service, including their ability to engage in real time
            activities through Service.
            <br />
            0.2. Use any robot, spider, or other automatic device, process, or
            means to access Service for any purpose, including monitoring or
            copying any of the material on Service.
            <br />
            0.3. Use any manual process to monitor or copy any of the material
            on Service or for any other unauthorized purpose without our prior
            written consent.
            <br />
            0.4. Use any device, software, or routine that interferes with the
            proper working of Service.
            <br />
            0.5. Introduce any viruses, trojan horses, worms, logic bombs, or
            other material which is malicious or technologically harmful.
            <br />
            0.6. Attempt to gain unauthorized access to, interfere with, damage,
            or disrupt any parts of Service, the server on which Service is
            stored, or any server, computer, or database connected to Service.
            <br />
            0.7. Attack Service via a denial-of-service attack or a distributed
            denial-of-service attack.
            <br />
            0.8. Take any action that may damage or falsify Company ratings.
            <br />
            0.9. Otherwise attempt to interfere with the proper working of
            Service.
          </p>

          <h2 id="analytics">12. Analytics</h2>
          <p
            ref={(element) => {
              ref12.current = element;
            }}
          >
            We may use third-party Service Providers to monitor and analyze the
            use of our Service.
          </p>

          <h2 id="minors">13. No Use By Minors</h2>
          <p
            ref={(element) => {
              ref13.current = element;
            }}
          >
            Service is intended only for access and use by individuals at least
            eighteen (18) years old. By accessing or using Service, you warrant
            and represent that you are at least eighteen (18) years of age and
            with the full authority, right, and capacity to enter into this
            agreement and abide by all of the terms and conditions of Terms. If
            you are not at least eighteen (18) years old, you are prohibited
            from both the access and usage of Service.
          </p>

          <h2 id="accounts">14. Accounts</h2>
          <p
            ref={(element) => {
              ref14.current = element;
            }}
          >
            When you create an account with us, you guarantee that you are above
            the age of 18, and that the information you provide us is accurate,
            complete, and current at all times. Inaccurate, incomplete, or
            obsolete information may result in the immediate termination of your
            account on Service.
            <br />
            <br />
            You are responsible for maintaining the confidentiality of your
            account and password, including but not limited to the restriction
            of access to your computer and/or account. You agree to accept
            responsibility for any and all activities or actions that occur
            under your account and/or password, whether your password is with
            our Service or a third-party service. You must notify us immediately
            upon becoming aware of any breach of security or unauthorized use of
            your account.
            <br />
            <br />
            You may not use as a username the name of another person or entity
            or that is not lawfully available for use, a name or trademark that
            is subject to any rights of another person or entity other than you,
            without appropriate authorization. You may not use as a username any
            name that is offensive, vulgar or obscene.
            <br />
            <br />
            We reserve the right to refuse service, terminate accounts, remove
            or edit content, or cancel orders at our sole discretion.
          </p>

          <h2 id="intellectual-property">15. Intellectual Property</h2>
          <p
            ref={(element) => {
              ref15.current = element;
            }}
          >
            Service and its original content (excluding Content provided by
            users), features and functionality are and will remain the exclusive
            property of Inawo and its licensors. Service is protected by
            copyright, trademark, and other laws of and foreign countries. Our
            trademarks may not be used in connection with any product or service
            without the prior written consent of Inawo.
          </p>

          <h2 id="copyright-property">16. Copyright Property</h2>
          <p
            ref={(element) => {
              ref16.current = element;
            }}
          >
            We respect the intellectual property rights of others. It is our
            policy to respond to any claim that Content posted on Service
            infringes on the copyright or other intellectual property rights
            (“Infringement”) of any person or entity.
            <br />
            <br />
            If you are a copyright owner, or authorized on behalf of one, and
            you believe that the copyrighted work has been copied in a way that
            constitutes copyright infringement, please submit your claim via
            email to hello@inawo.co, with the subject line: “Copyright
            Infringement” and include in your claim a detailed description of
            the alleged Infringement as detailed below, under “DMCA Notice and
            Procedure for Copyright Infringement Claims”
            <br />
            <br />
            You may be held accountable for damages (including costs and
            attorneys&apos; fees) for misrepresentation or bad-faith claims on
            the infringement of any Content found on and/or through Service on
            your copyright.
          </p>

          <h2 id="dmca">
            17. Notice and Procedure for Copyright Infringement Claims
          </h2>
          <p
            ref={(element) => {
              ref17.current = element;
            }}
          >
            You may submit a notification pursuant to the Digital Millennium
            Copyright Act (DMCA) by providing our Copyright Agent with the
            following information in writing (see 17 U.S.C 512(c)(3) for further
            detail):
            <br />
            <br />
            0.1. an electronic or physical signature of the person authorized to
            act on behalf of the owner of the copyright&apos;s interest;
            <br />
            0.2. a description of the copyrighted work that you claim has been
            infringed, including the URL (i.e., web page address) of the
            location where the copyrighted work exists or a copy of the
            copyrighted work;
            <br />
            0.3. identification of the URL or other specific location on Service
            where the material that you claim is infringing is located;
            <br />
            0.4. your address, telephone number, and email address;
            <br />
            0.5. a statement by you that you have a good faith belief that the
            disputed use is not authorized by the copyright owner, its agent, or
            the law;
            <br />
            0.6. a statement by you, made under penalty of perjury, that the
            above information in your notice is accurate and that you are the
            copyright owner or authorized to act on the copyright owner&apos;s
            behalf.
            <br />
            <br />
            You can contact our Copyright Agent via email at{" "}
            <a href="mailto:hello@inawo.co">hello@inawo.co</a>.
          </p>

          <h2 id="error-reporting">18. Error Reporting and Feedback</h2>
          <p
            ref={(element) => {
              ref18.current = element;
            }}
          >
            You may provide us either directly at hello@inawo.co or via third
            party sites and tools with information and feedback concerning
            errors, suggestions for improvements, ideas, problems, complaints,
            and other matters related to our Service (“Feedback”). You
            acknowledge and agree that:
            <br />
            (i) you shall not retain, acquire or assert any intellectual
            property right or other right, title or interest in or to the
            Feedback
            <br />
            (ii) Company may have development ideas similar to the Feedback
            <br />
            (iii) Feedback does not contain confidential information or
            proprietary information from you or any third party
            <br />
            (iv) Company is not under any obligation of confidentiality with
            respect to the Feedback. In the event the transfer of the ownership
            to the Feedback is not possible due to applicable mandatory laws,
            you grant Company and its affiliates an exclusive, transferable,
            irrevocable, free-of-charge, sub-licensable, unlimited and perpetual
            right to use (including copy, modify, create derivative works,
            publish, distribute and commercialize) Feedback in any manner and
            for any purpose.
          </p>

          <h2 id="links-to-sites">19. Links To Other Websites</h2>
          <p
            ref={(element) => {
              ref19.current = element;
            }}
          >
            Our Service may contain links to third party web sites or services
            that are not owned or controlled by Inawo.
            <br />
            <br />
            Inawo has no control over, and assumes no responsibility for the
            content, privacy policies, or practices of any third party web sites
            or services. We do not warrant the offerings of any of these
            entities/individuals or their websites.
            <br />
            <br />
            You acknowledge and agree that company shall not be responsible or
            Liable, directly or indirectly, for any damage or loss caused or
            Alleged to be caused by or in connection with use of or reliance on
            Any such content, goods or services available on or through any such
            Third party web sites or services.
            <br />
            We strongly advise you to read the terms of service and privacy
            Policies of any third party web sites or services that you visit.
          </p>

          <h2 id="disclaimer-of-warranty">20. Disclaimer Of Warranty</h2>
          <p
            ref={(element) => {
              ref20.current = element;
            }}
          >
            These services are provided by company on an “as is” and “as
            Available” basis. Company makes no representations or warranties of
            Any kind, express or implied, as to the operation of their services,
            Or the information, content or materials included therein. You
            Expressly agree that your use of these services, their content, and
            Any services or items obtained from us is at your sole risk.
            <br />
            <br />
            Neither company nor any person associated with company makes any
            Warranty or representation with respect to the completeness,
            Security, reliability, quality, accuracy, or availability of the
            Services. Without limiting the foregoing, neither company nor anyone
            Associated with company represents or warrants that the services,
            Their content, or any services or items obtained through the
            Services will be accurate, reliable, error-free, or uninterrupted,
            That defects will be corrected, that the services or the server that
            Makes it available are free of viruses or other harmful components
            Or that the services or any services or items obtained through the
            Services will otherwise meet your needs or expectations.
            <br />
            <br />
            Company hereby disclaims all warranties of any kind, whether express
            Or implied, statutory, or otherwise, including but not limited to
            Any warranties of merchantability, non-infringement, and fitness for
            Particular purpose.
            <br />
            <br />
            The foregoing does not affect any warranties which cannot be
            Excluded or limited under applicable law.
          </p>

          <h2 id="limitation-of-liability">21. Limitation Of Liability</h2>
          <p
            ref={(element) => {
              ref21.current = element;
            }}
          >
            Except as prohibited by law, you will hold us and our officers,
            Directors, employees, and agents harmless for any indirect,
            Punitive, special, incidental, or consequential damage, however it
            Arises (including attorneys&apos; fees and all related costs and
            Expenses of litigation and arbitration, or at trial or on appeal, if
            Any, whether or not litigation or arbitration is instituted),
            Whether in an action of contract, negligence, or other tortious
            Action, or arising out of or in connection with this agreement,
            Including without limitation any claim for personal injury or
            Property damage, arising from this agreement and any violation by
            You of any federal, state, or local laws, statutes, rules, or
            Regulations, even if company has been previously advised of the
            Possibility of such damage. Except as prohibited by law, if there is
            Liability found on the part of company, it will be limited to the
            Amount paid for the products and/or services, and under no
            Circumstances will there be consequential or punitive damages. Some
            States do not allow the exclusion or limitation of punitive,
            Incidental or consequential damages, so the prior limitation or
            Exclusion may not apply to you.
          </p>

          <h2 id="termination">22. Termination</h2>
          <p
            ref={(element) => {
              ref22.current = element;
            }}
          >
            We may terminate or suspend your account and bar access to Service
            immediately, without prior notice or liability, under our sole
            discretion, for any reason whatsoever and without limitation,
            including but not limited to a breach of Terms.
            <br />
            <br />
            If you wish to terminate your account, you may simply discontinue
            using Service.
            <br />
            All provisions of Terms which by their nature should survive
            termination shall survive termination, including, without
            limitation, ownership provisions, warranty disclaimers, indemnity
            and limitations of liability
          </p>

          <h2 id="governing-law">23. Governing Law</h2>
          <p
            ref={(element) => {
              ref23.current = element;
            }}
          >
            These Terms shall be governed and construed in accordance with the
            laws of Nigeria, which governing law applies to agreement without
            regard to its conflict of law provisions.
            <br />
            <br />
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights. If any provision of
            these Terms is held to be invalid or unenforceable by a court, the
            remaining provisions of these Terms will remain in effect. These
            Terms constitute the entire agreement between us regarding our
            Service and supersede and replace any prior agreements we might have
            had between us regarding Service.
          </p>

          <h2 id="changes-to-service">24. Changes to Service</h2>
          <p
            ref={(element) => {
              ref24.current = element;
            }}
          >
            We reserve the right to withdraw or amend our Service, and any
            service or material we provide via Service, in our sole discretion
            without notice. We will not be liable if for any reason all or any
            part of Service is unavailable at any time or for any period. From
            time to time, we may restrict access to some parts of Service, or
            the entire Service, to users, including registered users.
          </p>

          <h2 id="amendments-to-terms">25. Amendments to Terms</h2>
          <p
            ref={(element) => {
              ref25.current = element;
            }}
          >
            We may amend Terms at any time by posting the amended terms on this
            site. It is your responsibility to review these Terms periodically.
            <br />
            <br />
            Your continued use of the Platform following the posting of revised
            Terms means that you accept and agree to the changes. You are
            expected to check this page frequently so you are aware of any
            changes, as they are binding on you.
            <br />
            <br />
            By continuing to access or use our Service after any revisions
            become effective, you agree to be bound by the revised terms. If you
            do not agree to the new terms, you are no longer authorized to use
            Service.
          </p>

          <h2 id="waiver-and-severability">26. Waiver And Severability</h2>
          <p
            ref={(element) => {
              ref26.current = element;
            }}
          >
            No waiver by Company of any term or condition set forth in Terms
            shall be Inawomed a further or continuing waiver of such term or
            condition or a waiver of any other term or condition, and any
            failure of Company to assert a right or provision under Terms shall
            not constitute a waiver of such right or provision.
            <br />
            <br />
            If any provision of Terms is held by a court or other tribunal of
            competent jurisdiction to be invalid, illegal or unenforceable for
            any reason, such provision shall be eliminated or limited to the
            minimum extent such that the remaining provisions of Terms will
            continue in full force and effect.
          </p>

          <h2 id="acknowledgement">27. Acknowledgement</h2>
          <p
            ref={(element) => {
              ref27.current = element;
            }}
          >
            BY USING SERVICE OR OTHER SERVICES PROVIDED BY US, YOU ACKNOWLEDGE
            THAT YOU HAVE READ THESE TERMS OF SERVICE AND AGREE TO BE BOUND BY
            THEM.
          </p>

          <h2 id="contact-us">28. Contact Us</h2>
          <p
            ref={(element) => {
              ref28.current = element;
            }}
          >
            Please send your feedback, comments, requests for technical support
            by email: <a href="mailto:hello@inawo.co">hello@inawo.co</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Terms;
